import styled from 'styled-components';

export const LoaderStyles = styled.div`
  display: flex;
  justify-content: center;
`;
